export default __webpack_public_path__ + "static/media/kivy.39ec97c3.png";